export class Formatter {
    /**
     * Handles auto-formatting of the phone number on entry
     */
    public static phoneNumber() {
        // If already expanded, revert to base maxlength
        if ($(this).attr(`maxlength`) === `14` || $(this).attr(`maxlength`) === `16`) {
            $(this).attr(`maxlength`, `11`);
        }

        // Remove characters that are not numbers
        let phoneNumber = $(this).val().replace(/[^\d]/g, ``);

        // Set minlength based on a leading 1
        if (phoneNumber[0] === `1`) {
            $(this).attr(`minlength`, `11`);
        } else {
            $(this).attr(`minlength`, `10`);
        }

        // Format a phone number without a leading 1
        if (phoneNumber.length === 10 && phoneNumber[0] !== `1`) {
            phoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
            $(this).attr(`maxlength`, `14`);

            // Else format a phone number with a leading 1
        } else if (phoneNumber.length === 11 && phoneNumber[0] === `1`) {
            phoneNumber = phoneNumber.replace(/1(\d{3})(\d{3})(\d{4})/, '1 ($1) $2-$3');
            $(this).attr(`maxlength`, `16`);
        }

        // Re-assign formatted value
        $(this).val(phoneNumber);
    }
}
